import { type FC } from "react";
import { FormProvider } from "react-hook-form";
import { Heading } from "@root/shared/components/Heading";
import { Table, Td, Th, Tr } from "@root/shared/components/Table";
import { type PresentationProps } from "./type";
import { GuidanceBox } from "./uiParts/GuidanceBox";
import { InputNotAdoptedDetail } from "./uiParts/InputNotAdoptedDetail";
import { InputMessage } from "./uiParts/InputMessage";
import { SubmitButtons } from "./uiParts/SubmitButtons";
import * as styles from "./styles.css";

export const Presentation: FC<PresentationProps> = ({
  userName,
  isPayPerJobEntryFeeType,
  notAdoptedReasons,
  mailChoices,
  mailDetail,
  methods,
  completedInterview,
  mailBodyParts,
  handleRadioButtonChange,
  isChecked,
  handleChangeCheckbox,
  notAdoptedDescriptionTextLength,
  handleTextAreaChange,
  onSubmit,
  returnPagePath,
  recruitmentFeePath,
  gaLabel,
  isSp,
  isApp,
  formEl,
  updateNotAdoptedPath,
  token,
  isLoading,
}) => {
  return (
    <>
      <div className={styles.userNameBox}>
        <GuidanceBox isSp={isSp} />
        <Table className={styles.userNameRow}>
          <Tr>
            <Th width="168px">応募者氏名</Th>
            <Td>{userName}</Td>
          </Tr>
        </Table>
      </div>
      <FormProvider {...methods}>
        <form
          ref={formEl}
          onSubmit={methods.handleSubmit(onSubmit)}
          id="form"
          action={updateNotAdoptedPath}
          method="post"
        >
          <input type="hidden" name="authenticity_token" value={token} />
          <Heading tag="h2" size="large" bold className={styles.heading}>
            リジョブへの不採用報告
          </Heading>
          <InputNotAdoptedDetail
            notAdoptedReasons={notAdoptedReasons}
            completedInterview={completedInterview}
            isPayPerJobEntryFeeType={isPayPerJobEntryFeeType}
            handleRadioButtonChange={handleRadioButtonChange}
            isChecked={isChecked}
            handleChangeCheckbox={handleChangeCheckbox}
            notAdoptedDescriptionTextLength={notAdoptedDescriptionTextLength}
            handleTextAreaChange={handleTextAreaChange}
            recruitmentFeePath={recruitmentFeePath}
            isSp={isSp}
          />

          <Heading tag="h2" size="large" bold className={styles.heading}>
            応募者へのメール
          </Heading>
          <InputMessage
            mailChoices={mailChoices}
            mailDetail={mailDetail}
            userName={userName}
            mailBodyParts={mailBodyParts}
            isSp={isSp}
          />

          <SubmitButtons
            returnPagePath={returnPagePath}
            gaLabel={gaLabel}
            isApp={isApp}
            isLoading={isLoading}
          />
        </form>
      </FormProvider>
    </>
  );
};
